module.exports = __webpack_public_path__ + "img/light3.df36aa50.png";